import { TYPE_RANGE, TYPE_NUMBER } from "@/constants/numberValueTypes";
import { getUnique } from "@/utils/number/unique";
import { AccrualPeriod, formatAccrualPeriod } from "@/entities/models/accrual-period";
import { ProductionStandard, formatProductionStandard } from "@/entities/models/production-standard";
import { arrayFrom } from "@/utils/array/array-from";
import { getFilialData } from "./filial-settings";
import { mergeSettings } from "./utils";

const fields = {
    workloadType: "type_load",
    unitType: "unit_id",
    orderTypes: "order_type",
    places: "iiko_places",
    categories: "iiko_item_categories",
    categoriesExcept: "exclCategories",
    workloadExceptions: "workload_exceptions",
    additionalWorkloads: "over_workload",
};

// MODELS

function WorkloadExceptionModel(data = {}) {
    return {
        id: getUnique(),
        accrualPeriod: AccrualPeriod(data),
        productionStandard: ProductionStandard(data),
    };
}

function formatWorkloadExceptionData(exception) {
    const { accrualPeriod, productionStandard } = exception;

    return {
        ...formatAccrualPeriod(accrualPeriod),
        ...formatProductionStandard(productionStandard),
    };
}

function AdditionWorkloadModel(data = {}) {
    return {
        name: data.name,
        type: data.workload_type,
        ratio: data.value,
    };
}

function formatAdditionalWorkloadModel(data) {
    return {
        workload_type: data.type,
        name: data.name,
        value: data.ratio,
    };
}

// FORMAT FOR CLIENT

const clientFormatters = {
    orderTypes: (value) => value || [],
    categories: (value) => value || [],
    categoriesExcept: (value) => !!value,
    workloadExceptions: (value) => arrayFrom(value).map(WorkloadExceptionModel),
    additionalWorkloads: (value) => arrayFrom(value).map(AdditionWorkloadModel),
};

function formatWorkloadFields(settings, emptyFields) {
    const result = {};
    if (!settings) return;

    Object.entries(fields).forEach(([field, fieldName]) => {
        if (!emptyFields && !(fieldName in settings)) return;
        if (!settings || !(fieldName in settings)) return;

        const value = settings[fieldName];
        if (clientFormatters[field]) {
            result[field] = clientFormatters[field](value);
        } else {
            result[field] = value;
        }
    });


    if ("proceeds_min" in settings || "norm" in settings) {
        const { proceeds_min, norm } = settings;
        result.productionStandard = {
            type: proceeds_min!==undefined ? TYPE_RANGE : TYPE_NUMBER,
            number: isNaN(norm) ? "" : norm,
            from: isNaN(proceeds_min) ? "" : proceeds_min,
            to: isNaN(norm) ? "" : norm,
        };
    }
    return result;
}

export function ProductionPositionWorkload(positionData, filialId) {
    const baseSettings = positionData.setting;

    let workloadSettings = baseSettings;
    let workloadDiff = {};

    if (filialId) {
        const filialSettings = getFilialData(positionData, filialId) || {};

        // Исключения для филиала отдельно

        if (!("workload_exceptions" in filialSettings)) filialSettings.workload_exceptions = [];

        const { settings, diff } = mergeSettings(baseSettings, filialSettings);
        workloadSettings = settings;
        workloadDiff = diff;
    }


    return {
        value: formatWorkloadFields(workloadSettings, true),
        diff: formatWorkloadFields(workloadDiff),
    };
}

// FORMAT FOR SERVER

const serverFormatters = {
    workloadExceptions: (data) => data.map(formatWorkloadExceptionData),
    additionalWorkloads: (data) => data.map(formatAdditionalWorkloadModel),
};

export function formatProductionPositionWorkload(positionData) {
    console.log(positionData);
    const { productionStandard, ...otherFields } = positionData;

    const params = {
        ...formatProductionStandard(productionStandard),
    };

    Object.entries(otherFields).forEach(([key, value]) => {
        const fieldName = fields[key];
        if (fieldName) {
            if (serverFormatters[key]) {
                params[fieldName] = serverFormatters[key](value);
            } else {
                params[fieldName] = value;
            }
        }
    });

    return params;
}
